export default "__VITE_ASSET__oDdQ27sm__"